<template>
    <div>
        <htmlHeader :top_index="0" :menuCode="false" :crumbsShow="true" />

        <div style="width: 1200px; margin: auto;     padding-bottom: 10%; overflow: hidden;">
            <userLeft :active="8" />
            <div class="box5" v-if="isshow">
                <div style="overflow: hidden;">
                    <div class="box6" style="float: left;">企业信息</div>
                </div>
                <div class="box7"></div>
                <div style="overflow: hidden; margin-top: 2%;">
                    <div class="item_title"><span style="color: red;"></span> {{ isSchool ? '院校全称' : '企业全称' }}：</div>
                    <span style="float: left;width: 300px; margin-left: 20px; margin-top: 15px;"> {{ qiyexinxi }}</span>
                    <div style="float:right;" class="submit_but" @click="showmod">修改</div>
                </div>
                <div style="overflow: hidden; margin-top: 2%;">
                    <div class="item_title"><span style="color: red;"></span> 统一社会信用代码：</div>
                    <span style="float: left;width: 300px; margin-left: 20px; margin-top: 15px;">
                        {{ obj.unifiedSocialCreditCode }}
                    </span>
                </div>
                <div style="overflow: hidden; margin-top: 2%;">
                    <div class="item_title"><span style="color: red;"></span> 所在地区：</div>
                    <span style="float: left;width: 300px; margin-left: 20px; margin-top: 15px;"> {{ obj.district.district1 }}-{{ obj.district.district2 }}-{{ obj.district.district3 }} </span>
                </div>
                <div style="overflow: hidden; margin-top: 2%;">
                    <div class="item_title"><span style="color: red;"></span> 详细地址：</div>
                    <span style="float: left;width: 300px; margin-left: 20px; margin-top: 15px;">
                        {{ obj.district.districtDetail }}
                    </span>
                </div>
                <div style="overflow: hidden; margin-top: 2%;">
                    <div class="item_title"><span style="color: red;"></span> 行业领域：</div>
                    <span style="float: left;width: 300px; margin-left: 20px; margin-top: 15px;">{{ obj.industry }}</span>
                </div>
                <div style="overflow: hidden; margin-top: 2%;">
                    <div class="item_title"><span style="color: red;"></span> 用户分类：</div>
                    <span style="float: left;width: 300px; margin-left: 20px; margin-top: 15px;">{{ obj.userType }}</span>
                </div>

                <template v-if="isSchool">
                    <div style="overflow: hidden; margin-top: 2%;">
                        <div class="item_title"><span style="color: red;"></span> 课题组老师姓名：</div>
                        <span style="float: left;width: 300px; margin-left: 20px; margin-top: 15px;">{{ obj.teacherName }}</span>
                    </div>
                    <div style="overflow: hidden; margin-top: 2%;">
                        <div class="item_title"><span style="color: red;"></span> 联系电话：</div>
                        <span style="float: left;width: 300px; margin-left: 20px; margin-top: 15px;">{{ obj.teacherMobile }}</span>
                    </div>
                    <div style="overflow: hidden; margin-top: 2%;">
                        <div class="item_title"><span style="color: red;"></span> 所在学院/部门：</div>
                        <span style="float: left;width: 300px; margin-left: 20px; margin-top: 15px;">{{ obj.collegeDepartment }}</span>
                    </div>
                </template>

                <!-- <div style="overflow: hidden; margin-top: 2%;">
                    <div class="item_title"><span style="color: red;"></span> 开户银行：</div>
                    <span style="float: left;width: 300px; margin-left: 20px; margin-top: 15px;">{{ obj.bankName }}</span>
                </div> -->
                <!-- <div style="overflow: hidden; margin-top: 2%;">
                    <div class="item_title"><span style="color: red;"></span> 开户银行卡号：</div>
                    <span style="float: left;width: 300px; margin-left: 20px; margin-top: 15px;">{{ obj.bankAccount }}</span>
                </div> -->
                <!-- <div style="overflow: hidden; margin-top: 2%;">
                    <div class="item_title"><span style="color: red;"></span> 开户名称：</div>
                    <span style="float: left;width: 300px; margin-left: 20px; margin-top: 15px;">{{ obj.bankUserName }}</span>
                </div> -->

                <div style="overflow: hidden; margin-top: 2%;">
                    <div class="item_title"><span style="color: red;"></span> 证件信息：</div>
                    <div style="float: left;margin-left: 20px;" v-if="isSchool">
                        <div style="float: left; margin-right:10px" v-for="item in JSON.parse(obj.idCardSchool)" :key="item">
                            <img style="width: 90px; height: 90px;" :src="'/api/file/preview/' + item" alt="avatar" />
                        </div>
                    </div>
                    <div style="float: left;margin-left: 20px;" v-else>
                        <div style="float: left;">
                            <img style="width: 90px; height: 90px;" v-if="imgid1" :src="'/api/file/preview/' + imgid1" alt="avatar" />
                        </div>
                        <div style="float: left; margin-left: 20px;">
                            <img style="width: 90px; height: 90px;" v-if="imgid2" :src="'/api/file/preview/' + imgid2" alt="avatar" />
                        </div>
                        <div style="float: left; margin-left: 20px;">
                            <img style="width: 90px; height: 90px;" v-if="imgid3" :src="'/api/file/preview/' + imgid3" alt="avatar" />
                        </div>
                    </div>
                </div>
                <div style="overflow: hidden; margin-top: 2%;">
                    <div class="item_title"><span style="color: red;"></span> 法定代表人：</div>
                    <span style="float: left;width: 300px; margin-left: 20px; margin-top: 15px;">{{ obj.legalRepresentative }}</span>
                </div>
                <div style="overflow: hidden; margin-top: 2%;">
                    <div class="item_title"><span style="color: red;"></span> 成立日期：</div>
                    <span style="float: left;width: 300px; margin-left: 20px; margin-top: 15px;">{{ obj.registrationDate }}</span>
                </div>
                <div style="overflow: hidden; margin-top: 2%;">
                    <div class="item_title"><span style="color: red;"></span> 营业期限：</div>
                    <span v-if="obj.businessEnd" style="float: left;width: 300px; margin-left: 20px; margin-top: 15px;">{{ obj.businessStart }} - {{ obj.businessEnd }}</span>
                    <span v-else style="float: left;width: 300px; margin-left: 20px; margin-top: 15px;">{{ obj.businessStart }} - 长期有效</span>
                </div>
                <!-- <div class="xuxian"></div> -->

                <div style="overflow: hidden; margin-top: 2%;">
                    <div class="item_title"><span style="color: red;"></span> 交易类型：</div>
                    <span style="float: left;width: 300px; margin-left: 20px; margin-top: 15px;">{{ obj.tradeType }}</span>
                </div>
                <div style="overflow: hidden; margin-top: 2%;">
                    <div class="item_title"><span style="color: red;"></span> 实验室名称：</div>
                    <span style="float: left;width: 300px; margin-left: 20px; margin-top: 15px;">{{ obj.laboratoryName }}</span>
                </div>

                <div style="overflow: hidden; margin-top: 2%;">
                    <div class="item_title"><span style="color: red;"></span> 公司主页：</div>
                    <span style="float: left;width: 300px; margin-left: 20px; margin-top: 15px;">{{ obj.companyWebsite }}</span>
                </div>

                <div style="overflow: hidden; margin-top: 2%;">
                    <div class="item_title"><span style="color: red;"></span> 联系人：</div>
                    <span style="float: left;width: 300px; margin-left: 20px; margin-top: 15px;">{{ obj.contacts }}</span>
                </div>

                <div style="overflow: hidden; margin-top: 2%;">
                    <div class="item_title"><span style="color: red;"></span> 手机号：</div>
                    <span style="float: left;width: 300px; margin-left: 20px; margin-top: 15px;">{{ obj.phone }}</span>
                </div>

                <div style="overflow: hidden; margin-top: 2%;">
                    <div class="item_title"><span style="color: red;"></span> 座机：</div>
                    <span style="float: left;width: 300px; margin-left: 20px; margin-top: 15px;">{{ obj.areaCode }}-{{ obj.festnetznummer }}-{{ obj.festnetznummer2 }}</span>
                </div>
            </div>

            <div class="box5" v-else>
                <div style="overflow: hidden;">
                    <div class="box6" style="float: left;">企业信息</div>
                </div>
                <div class="box7"></div>
                <div style="overflow: hidden; margin-top: 2%;">
                    <div class="item_title"><span style="color: red;">*</span> {{ isSchool ? '院校全称' : '企业全称' }}：</div>
                    <a-input v-model="obj.companyFullName" placeholder="请输入企业全称" style="float: left;width: 300px; margin-left: 20px; margin-top: 10px;" />
                    <!-- <div style="margin-top:15px;margin-left:205px">{{qiyexinxi}}</div> -->
                </div>
                <div style="overflow: hidden; margin-top: 2%;">
                    <div class="item_title"><span style="color: red;">*</span> 统一社会信用代码：</div>
                    <a-input v-model="obj.unifiedSocialCreditCode" placeholder="请输入统一社会信用代码" style="float: left;width: 300px; margin-left: 20px; margin-top: 10px;" />
                </div>
                <div style="overflow: hidden; margin-top: 2%;">
                    <div class="item_title"><span style="color: red;">*</span> 所在地区：</div>
                    <div style="overflow: hidden;">
                        <a-select style="float: left;width: 86px; margin-left: 20px; margin-top: 10px;" v-model="obj.district.district1Id" placeholder="请选择省" @change="sheng_Change">
                            <a-select-option :key="index" v-for="(item, index) in all_available" :value="item.id">
                                {{ item.name }}
                            </a-select-option>
                        </a-select>
                        <a-select style="float: left;width: 86px; margin-left: 20px; margin-top: 10px;" v-model="obj.district.district2" placeholder="请选择市" @change="shi_Change">
                            <a-select-option :key="index" v-for="(item, index) in all_shi" :value="item.id">
                                {{ item.name }}
                            </a-select-option>
                        </a-select>
                        <a-select style="float: left;width: 86px; margin-left: 20px; margin-top: 10px;" v-model="obj.district.district3" placeholder="请选择区" @change="qu_Change">
                            <a-select-option :key="index" v-for="(item, index) in all_qu" :value="item.id">
                                {{ item.name }}
                            </a-select-option>
                        </a-select>
                    </div>
                </div>

                <div style="overflow: hidden; margin-top: 2%;">
                    <div class="item_title"><span style="color: red;">*</span> 详细地址：</div>
                    <a-input v-model="obj.district.districtDetail" placeholder="请输入详细地址" style="float: left;width: 300px; margin-left: 20px; margin-top: 10px;" />
                </div>
                <div style="overflow: hidden; margin-top: 2%;">
                    <div class="item_title"><span style="color: red;">*</span> 行业领域：</div>
                    <a-select :value="obj.industry ? obj.industry : '请选择'" default-value="请选择" style="float: left;width: 300px; margin-left: 20px; margin-top: 10px;" @change="hangyelingyu_change">
                        <a-select-option :key="index" v-for="(item, index) in industry_list" :value="item">
                            {{ item }}
                        </a-select-option>
                    </a-select>
                </div>
                <div style="overflow: hidden; margin-top: 2%;">
                    <div class="item_title"><span style="color: red;">*</span> 用户分类：</div>
                    <a-select :value="obj.userType ? obj.userType : '请选择'" default-value="请选择" style="float: left;width: 300px; margin-left: 20px; margin-top: 10px;" @change="yonghufenlei_change">
                        <a-select-option :key="index" v-for="(item, index) in userType_list" :value="item">
                            {{ item }}
                        </a-select-option>
                    </a-select>
                </div>

                <template v-if="isSchool">
                    <div style="overflow: hidden; margin-top: 2%;">
                        <div class="item_title"><span style="color: red;">*</span> 课题组老师姓名：</div>
                        <a-input v-model="obj.teacherName" placeholder="请输入课题组老师姓名" style="float: left;width: 300px; margin-left: 20px; margin-top: 10px;" />
                    </div>
                    <div style="overflow: hidden; margin-top: 2%;">
                        <div class="item_title"><span style="color: red;">*</span> 联系电话：</div>
                        <a-input v-model="obj.teacherMobile" placeholder="请输入联系电话" style="float: left;width: 300px; margin-left: 20px; margin-top: 10px;" />
                    </div>
                    <div style="overflow: hidden; margin-top: 2%;">
                        <div class="item_title"><span style="color: red;">*</span> 所在学院/部门：</div>
                        <a-input v-model="obj.collegeDepartment" placeholder="请输入所在学院/部门" style="float: left;width: 300px; margin-left: 20px; margin-top: 10px;" />
                    </div>
                </template>
                <!-- <div style="overflow: hidden; margin-top: 2%;">
                    <div class="item_title"><span style="color: red;"></span> 开户银行：</div>
                    <a-input v-model="obj.bankName" placeholder="请输入开户银行" style="float: left;width: 300px; margin-left: 20px; margin-top: 10px;" />
                </div>
                <div style="overflow: hidden; margin-top: 2%;">
                    <div class="item_title"><span style="color: red;"></span> 开户银行卡号：</div>
                    <a-input v-model="obj.bankAccount" placeholder="请输入开户银行卡号" style="float: left;width: 300px; margin-left: 20px; margin-top: 10px;" />
                </div>
                <div style="overflow: hidden; margin-top: 2%;">
                    <div class="item_title"><span style="color: red;"></span> 开户名称：</div>
                    <a-input v-model="obj.bankUserName" placeholder="请输入开户名称" style="float: left;width: 300px; margin-left: 20px; margin-top: 10px;" />
                </div> -->

                <div style="overflow: hidden; margin-top: 2%;">
                    <div class="item_title"><span style="color: red;">*</span> 上传证件：</div>
                    <imgUpload style="float: left;margin-left: 20px;" v-if="isSchool" v-model="obj.idCardSchool" />
                    <div style="float: left;margin-left: 20px;" v-else>
                        <div style="float: left;">
                            <a-upload name="file" list-type="picture-card" class="avatar-uploader" :show-upload-list="false" action="/api/file/upload" @change="add_uploader1">
                                <img style="width: 90px; height: 90px;" v-if="imgid1" :src="'/api/file/preview/' + imgid1" alt="avatar" />
                                <div v-else>
                                    <div class="ant-upload-text">营业执照</div>
                                </div>
                            </a-upload>
                        </div>
                        <div style="float: left; margin-left: 20px;">
                            <a-upload name="file" list-type="picture-card" class="avatar-uploader" :show-upload-list="false" action="/api/file/upload" @change="add_uploader2">
                                <img style="width: 90px; height: 90px;" v-if="imgid2" :src="'/api/file/preview/' + imgid2" alt="avatar" />
                                <div v-else>
                                    <div class="ant-upload-text">法人身份证<br />正面</div>
                                </div>
                            </a-upload>
                        </div>
                        <div style="float: left; margin-left: 20px;">
                            <a-upload name="file" list-type="picture-card" class="avatar-uploader" :show-upload-list="false" action="/api/file/upload" @change="add_uploader3">
                                <img style="width: 90px; height: 90px;" v-if="imgid3" :src="'/api/file/preview/' + imgid3" alt="avatar" />
                                <div v-else>
                                    <div class="ant-upload-text">法人身份证<br />反面</div>
                                </div>
                            </a-upload>
                        </div>
                    </div>
                </div>
                <p style="margin-left:202px;font-size: 12px;" v-if="isSchool">注：请上传教师证<span style="color:#999999">(优先)</span>/学生证/校园卡等证件的图片，支持jpg、jpeg、png</p>

                <p style="margin-left:202px;font-size: 12px;" v-else>注: 上传营业执照、法定代表人身份证件正反面</p>
                <div style="overflow: hidden; margin-top: 2%;">
                    <div class="item_title"><span style="color: red;" v-if="!isSchool">*</span> 法定代表人：</div>
                    <a-input v-model="obj.legalRepresentative" placeholder="请输入法人" style="float: left;width: 300px; margin-left: 20px; margin-top: 10px;" />
                </div>

                <div style="overflow: hidden; margin-top: 2%;">
                    <div class="item_title"><span style="color: red;" v-if="!isSchool">*</span> 成立日期：</div>
                    <a-date-picker v-model="obj.registrationDate" placeholder="请选择成立日期" style="float: left;width: 300px; margin-left: 20px; margin-top: 10px;" />
                </div>
                <div style="overflow: hidden; margin-top: 2%;">
                    <div class="item_title"><span style="color: red;" v-if="!isSchool">*</span> 营业期限：</div>
                    <a-date-picker v-model="obj.businessStart" placeholder="请选择" style="float: left;width: 140px; margin-left: 20px; margin-top: 10px;" />
                    <a-date-picker v-model="obj.businessEnd" :showToday="false" placeholder="长期有效" style="float: left;width: 140px; margin-left: 20px; margin-top: 10px;">
                        <template slot="renderExtraFooter">
                            <a-button style="color:#2b9a34; margin-left:100px" @click="changqi">长期</a-button>
                        </template>
                    </a-date-picker>
                </div>
                <!-- <div class="xuxian"></div> -->

                <div style="overflow: hidden; margin-top: 2%;">
                    <div class="item_title"><span style="color: red;">*</span>交易类型：</div>
                    <a-select :value="obj.tradeType ? obj.tradeType : '请选择'" default-value="请选择" style="float: left;width: 300px; margin-left: 20px; margin-top: 10px;" @change="jiaoyiuleixin_change">
                        <a-select-option :key="index" v-for="(item, index) in tradeType_list" :value="item">
                            {{ item }}
                        </a-select-option>
                    </a-select>
                </div>

                <div style="overflow: hidden; margin-top: 2%;">
                    <div class="item_title"><span style="color: red;"></span> 实验室名称：</div>
                    <a-input v-model="obj.laboratoryName" placeholder="请输入实验室名称" style="float: left;width: 300px; margin-left: 20px; margin-top: 10px;" />
                </div>

                <div style="overflow: hidden; margin-top: 2%;">
                    <div class="item_title"><span style="color: red;"></span> 公司主页：</div>
                    <a-input v-model="obj.companyWebsite" placeholder="请输入公司主页" style="float: left;width: 300px; margin-left: 20px; margin-top: 10px;" />
                </div>

                <div style="overflow: hidden; margin-top: 2%;">
                    <div class="item_title"><span style="color: red;"></span> 联系人：</div>
                    <a-input v-model="obj.contacts" placeholder="请输入联系人" style="float: left;width: 300px; margin-left: 20px; margin-top: 10px;" />
                </div>

                <div style="overflow: hidden; margin-top: 2%;">
                    <div class="item_title"><span style="color: red;"></span> 手机号：</div>
                    <a-input v-model="obj.phone" placeholder="请输入手机号" style="float: left;width: 300px; margin-left: 20px; margin-top: 10px;" />
                </div>

                <div style="overflow: hidden; margin-top: 2%;">
                    <div class="item_title"><span style="color: red;"></span> 座机：</div>
                    <div style="overflow: hidden;">
                        <a-input v-model="obj.areaCode" placeholder="区号" style="float: left;width: 85px; margin-left: 20px; margin-top: 10px;" />
                        <a-input v-model="obj.festnetznummer" placeholder="座机号" style="float: left;width: 85px; margin-left: 20px; margin-top: 10px;" />
                        <a-input v-model="obj.festnetznummer2" placeholder="座机分号" style="float: left;width: 85px; margin-left: 20px; margin-top: 10px;" />
                    </div>
                </div>

                <div style="overflow: hidden; margin-top: 2%;">
                    <div style="overflow: hidden; text-align: left;">
                        <div class="submit_but" @click="save_obj">保存</div>
                    </div>
                </div>
            </div>
        </div>
        <foot />
    </div>
</template>

<script>
import axios from 'axios';
import userLeft from '../public/user_left';
import htmlHeader from '../public/head';
import foot from '../public/foot';
import imgUpload from './ImgUploadSP/ImgUpload.vue';
export default {
    name: 'integral',
    components: {
        userLeft,
        htmlHeader,
        foot,
        imgUpload
    },
    data() {
        return {
            isDisable: false,
            qiyexinxi: '',
            isshow: true,
            all_shi: '', // 下级市
            all_qu: '', // 下级区
            all_qu2: '',
            all_available: '', // 所有省份
            obj: {
                idCardSchool: '',
                teacherName: '',
                teacherMobile: '',
                collegeDepartment: '',
                address: '',
                areaCode: '',
                registrationDate: '',
                businessEnd: '',
                businessEnd: '',
                bankAccount: '',
                bankName: '',
                bankUserName: '',
                city: '',
                companyFullName: '',
                companyWebsite: '',
                contacts: '',
                county: '',
                festnetznummer: '',
                festnetznummer2: '',
                industry: '',
                laboratoryName: '',
                legalRepresentative: '',
                phone: '',
                province: '',
                scanList: [],
                tradeType: '',
                unifiedSocialCreditCode: '',
                userType: '',
                district: {
                    // 省
                    district1: '',
                    // 省id
                    district1Id: '',
                    // 市
                    district2: '',
                    // 市id
                    district2Id: '',
                    // 县
                    district3: '',
                    // 县id
                    district3Id: '',
                    // 详细地址
                    districtDetail: ''
                }
            }, //提交表单数据
            userType_list: '', //用户分类
            industry_list: '', //行业领域
            tradeType_list: '', //交易类型
            imgid1: '',
            imgid2: '',
            imgid3: '',
            isSchool: false
        };
    },
    methods: {
        changqi() {
            this.obj.businessEnd = null;
        },
        showmod() {
            var that = this;
            var islogin = localStorage.getItem('Access-Token');
            if (islogin) {
                this.isshow = false;
            }
        },
        // 获取三种下拉框的类型
        get_all_select_data() {
            // 企业信息 用户分类
            this.api.get_userType_content().then(res => {
                console.log(res);
                if (res.ok) {
                    this.userType_list = JSON.parse(res.data.description);
                } else {
                    this.$message.error(res.message);
                }
            });
            // 企业信息 行业领域
            this.api.get_industry_content().then(res => {
                if (res.ok) {
                    this.industry_list = JSON.parse(res.data.description);
                } else {
                    this.$message.error(res.message);
                }
            });
            // 企业信息 交易类型
            this.api.get_tradeType_content().then(res => {
                if (res.ok) {
                    this.tradeType_list = JSON.parse(res.data.description);
                } else {
                    this.$message.error(res.message);
                }
            });
        },
        // 最终提交
        save_obj() {
            // if (!/^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/.test(this.obj.phone)) {
            //         this.$message.error("请输入正确电话号码")
            //         return false
            //     }
            this.obj.licenseImage = this.imgid1;
            this.obj.corpIdCardImage = this.imgid2;
            this.obj.corpIdCardImageReverse = this.imgid3;
            let pass = false;
            if (this.isSchool) {
                if (this.obj.companyFullName && this.obj.unifiedSocialCreditCode && this.obj.teacherName && this.obj.teacherMobile && this.obj.collegeDepartment && this.obj.idCardSchool && this.obj.userType && this.obj.industry && this.obj.tradeType && this.obj.district && this.obj.district.district3 && this.obj.district.districtDetail) {
                    pass = true;
                }
            } else {
                // && this.obj.businessEnd
                if (this.obj.legalRepresentative  && this.obj.registrationDate && this.obj.businessStart && this.obj.companyFullName && this.obj.unifiedSocialCreditCode && this.imgid1 && this.imgid2 && this.imgid3 && this.obj.userType && this.obj.industry && this.obj.tradeType && this.obj.district && this.obj.district.district3 && this.obj.district.districtDetail) {
                    pass = true;
                }
            }
            if (pass) {
                this.api.save_user_company(this.obj).then(res => {
                    if (res.ok) {
                        this.isshow = true;
                        this.$message.success(res.message);
                        this.get_user_company_me();
                    } else {
                        this.$message.error(res.message);
                    }
                });
            } else {
                this.$message.error('请填写所有带有*号选项');
            }
        },
        // 上传
        add_uploader1(e) {
            
            if (e.file.status === 'done') {
                this.imgid1 = e.file.response.data.uuid;
            }
        },
        add_uploader2(e) {
            console.log(e);
            if (e.file.status === 'done') {
                this.imgid2 = e.file.response.data.uuid;
            }
        },
        add_uploader3(e) {
            if (e.file.status === 'done') {
                this.imgid3 = e.file.response.data.uuid;
            }
        },
        // 切换行业领域
        hangyelingyu_change(e) {
            this.obj.industry = e;
        },
        // 切换交易类型
        jiaoyiuleixin_change(e) {
            this.obj.tradeType = e;
        },
        // 切换用户分类
        yonghufenlei_change(e) {
            this.obj.userType = e;
            this.isSchool = e == '大专院校科研院所';
        },
        // 切换地址
        sheng_Change(id) {
            this.obj.district.district2 = '';
            this.obj.district.district3 = '';
            let row = this.all_available.find(item => item.id === id);
            this.obj.district.district1 = row.name;
            this.all_shi = row.children || [];
            this.obj.district.district1Id = id;
        },
        shi_Change(id) {
            let row = this.all_shi.find(item => item.id === id);
            this.obj.district.district2 = row.name;
            this.obj.district.district3 = '';

            this.all_qu = row.children || [];
            this.obj.district.district2Id = id;
        },
        qu_Change(id) {
            let row = this.all_qu.find(item => item.id === id);
            this.obj.district.district3 = row.name;
            this.all_qu2 = row.children || [];
            this.obj.district.district3Id = id;
        },
        // 获取地址资源
        get_all_available() {
            this.api.get_all_available().then(res => {
                this.all_available = res.data;
            });
        },
        // 获取我的企业信息
        get_user_company_me() {
            this.api.get_user_company_me().then(res => {
                this.isSchool = res.data.userType == '大专院校科研院所';
                console.log(res, '======================');
                if (res.ok && res.data) {
                    if (!res.data.district) {
                        res.data.district = {
                            // 省
                            district1: '',
                            // 省id
                            district1Id: '',
                            // 市
                            district2: '',
                            // 市id
                            district2Id: '',
                            // 县
                            district3: '',
                            // 县id
                            district3Id: '',
                            // 详细地址
                            districtDetail: ''
                        };
                    }

                    this.obj = res.data;
                    console.log(JSON.parse(this.obj.idCardSchool), '0000000000000000000000');
                    if (res.data) {
                        this.imgid1 = res.data.licenseImage || '';
                        this.imgid2 = res.data.corpIdCardImage || '';
                        this.imgid3 = res.data.corpIdCardImageReverse || '';
                    }
                }
            });
        }
    },
    created() {
        this.api.user_info().then(res => {
            if (res.data.kingdeeId !== null) this.isDisable = true;
            if (res.data.company) {
                this.isSchool = res.data.company.userType == '大专院校科研院所';
            }
        });
        this.api.get_companyFullName().then(res => {
            this.qiyexinxi = res.data;
            console.log(res, '企业信息');
        });
        this.get_all_available();
        this.get_all_select_data();
        this.get_user_company_me();
    }
};
</script>

<style scoped>
.box5 img {
    object-fit: cover;
}
.submit_but {
    width: 100px;
    height: 40px;
    border: 1px solid #2b9a34;
    text-align: center;
    line-height: 40px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #2b9a34;
    cursor: pointer;
    margin-left: 200px;
}

.xuxian {
    width: 100%;
    height: 1px;
    border-bottom: 1px dashed #e8e6e6;
    margin-top: 2%;
}

.item_title {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 42px;
    text-align: right;
    float: left;
    margin-top: 5px;
    width: 20%;
}

.box14 {
    width: 120px;
    height: 32px;
    border: 1px solid #2c9a34;
    float: right;
    text-align: center;
    line-height: 32px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #2c9a34;
}

.box13 {
    width: 16.6666%;
    height: 100%;
    float: left;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    line-height: 40px;
}

.box12 {
    width: 100%;
    height: 40px;
    background: #f4f4f4;
    margin-top: 4%;
}

.box11 {
    width: 100px;
    height: 32px;
    border: 1px solid #2b9a34;
    margin: 8% auto;
    text-align: center;
    line-height: 32px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #2b9a34;
}

.box10 {
    font-size: 40px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ff9629;
    /* line-height: 16px; */
    margin: 4% auto;
}

.box9 {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    margin: auto;
}

.box8 {
    width: 100%;
    height: 105px;
    background: EEF7EF;
    /* opacity: 0.08; */
    padding-top: 4%;
}

.box7 {
    width: 100%;
    height: 1px;
    border-top: 1px solid #e8e6e6;
    margin-top: 2%;
}

.box6 {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    /* margin-top: 2%; */
    text-align: left;
}

.box5 {
    min-height: 1023px;
    width: 80%;
    /* min-height: 1023px; */
    border: 1px solid #ede9e9;
    float: right;
    margin-top: 2%;
    padding: 2%;
}

.box3 {
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: Regular;
    color: #666666;
    margin-top: 6%;
}

.box4 {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
}

.box1 {
    width: 220px;
    min-height: 1023px;
    border: 1px solid #ede9e9;
    float: left;
    margin-top: 2%;
}

.box2 {
    width: 100%;
    height: 45px;
    background: #f2f2f2;
}
</style>



// WEBPACK FOOTER //
// src/components/enterprise_info.vue